import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Loader2, Plus, Trash2 } from 'lucide-react';
import { adminListIgnoredPhones, adminAddIgnoredPhone, adminRemoveIgnoredPhone } from '../api';
import { Section, TextInput } from '../components/product-edit/ui';

const BotIgnoredPage = () => {
  const qc = useQueryClient();
  const [phone, setPhone] = useState('');
  const [reason, setReason] = useState('');
  const [err, setErr] = useState('');

  const { data: rows = [], isLoading } = useQuery({
    queryKey: ['admin-bot-ignored'],
    queryFn: adminListIgnoredPhones,
  });

  const add = useMutation({
    mutationFn: adminAddIgnoredPhone,
    onSuccess: () => {
      setPhone(''); setReason(''); setErr('');
      qc.invalidateQueries({ queryKey: ['admin-bot-ignored'] });
    },
    onError: e => setErr(e?.response?.data?.detail || 'No se pudo agregar'),
  });
  const remove = useMutation({
    mutationFn: adminRemoveIgnoredPhone,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-bot-ignored'] }),
  });

  const submit = e => {
    e.preventDefault();
    if (phone.trim()) add.mutate({ phone: phone.trim(), reason: reason.trim() || null });
  };

  return (
    <div className="mx-auto max-w-2xl p-6">
      <h1 className="font-display text-lg font-semibold text-brand-text tracking-tight">Bot · Números ignorados</h1>
      <p className="mt-1 text-[12px] text-brand-muted">
        El bot no atiende a estos números (vendedores, proveedores, familiares, spam). Además, deja de atender automáticamente a quien tiene un pedido abierto ya avisado a los vendedores.
      </p>

      <form onSubmit={submit} className="mt-6 space-y-5">
        <Section title="Agregar número">
          <div className="space-y-5">
            <TextInput label="Teléfono" value={phone} onChange={e => setPhone(e.target.value)}
              placeholder="+51 956 787 186" />
            <TextInput label="Motivo (opcional)" value={reason} onChange={e => setReason(e.target.value)}
              placeholder="Vendedor, proveedor, spam…" />
            {err && <p className="text-[11px] text-brand-red">{err}</p>}
            <button type="submit" disabled={add.isPending || !phone.trim()}
              className="inline-flex items-center gap-2 rounded bg-brand-accent px-4 py-2 text-[12px] font-medium text-black disabled:opacity-50">
              {add.isPending ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Agregar
            </button>
          </div>
        </Section>
      </form>

      <div className="mt-8">
        {isLoading ? (
          <Loader2 size={16} className="animate-spin text-brand-muted" />
        ) : rows.length === 0 ? (
          <p className="text-[13px] text-brand-faint">Sin números ignorados.</p>
        ) : (
          <ul className="divide-y divide-brand-border-md">
            {rows.map(r => (
              <li key={r.id} className="flex items-center justify-between py-3">
                <div>
                  <p className="font-mono text-[13px] text-brand-text">+{r.phone}</p>
                  {r.reason && <p className="text-[12px] text-brand-muted">{r.reason}</p>}
                </div>
                <button onClick={() => remove.mutate(r.id)} aria-label="Quitar"
                  className="p-2 text-brand-faint hover:text-brand-red">
                  <Trash2 size={15} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default BotIgnoredPage;
